<template>
    <div class="container">
      <el-form label-width="180px" label-position="left" ref="formRef" :model="formData" :validate-on-rule-change="false">
        <FormItemComp ref="FormItemComp" :config="config" :form-state="root" :rootFormData="formData" :rootFormDataOptions="formDataOptions"></FormItemComp>
      </el-form>
    </div>
  </template>
  
  <script>
  import FormItemComp from './formItemComp.vue'
  import _ from 'lodash'
  import { showErrorTip } from '@/utils'

  export default {
    name: 'FormPage',
    components: {
      FormItemComp
    },
    props: {
      root: {
        type: Object,
        required: true,
      },
      config: Object
    },
    data() {
      return {
        
      }
    },
    computed: {
      formData() {
        const params = {};
        let root = this.root;
        const acients = []
        while(root?.payload) {
          acients.unshift(root)
          
          if(root.payload.props?.visible !== false && !root.payload.field.includes('title_')) {
            params[root.payload.field] = root.payload.value;
          }
          root = root.next(root, [...acients])
        }
        return params
      },
      formDataOptions() {
        const params = {};
        let root = this.root;
        const acients = []
        while(root?.payload) {
          acients.unshift(root);
          if(root.payload.props.defaultData) {
            params[root.payload.field] = root.payload.props.defaultData;
          }
          // action
          root = root.next(root, [...acients])
        }
        return params
      }
    },
    methods: {
        async getFormData() {

            try {
                let res = await this.$refs.formRef.validate();
                return  { ...this.formData }
            } catch (error) {
              console.log('error', error)
                let firstError = _.keys(error)[0]
                if(firstError) {
                  // 在页面找到 label标签，for="app_id" ,for属性的值与firstError一致的元素，获得在页面中的位置，并滚动到该元素
                  showErrorTip({
                    selectors: firstError
                  })
                }
            }
        },
        clearFormValidate() {
          this.$refs.formRef.clearValidate()
        }
    }
  }
  </script>
  
  <style scoped>
  .container {
    padding: 0 20px;
  }
  </style> 